import Grid, { type GridItem, type ID } from "@client/controls/Grid/component";

import React from "react";

export interface GridListGridProps<TItemProps extends {} = {}, TItem extends GridItem = GridItem> {
  columns: number;
  gutter: number | string;

  items: Array<TItem | ID>;
  ItemComponent: React.ComponentType<TItemProps & TItem>;
  itemProps?: Partial<TItemProps>;
}

export default <TItemProps extends {} = {}, TItem extends GridItem = GridItem>({
  gutter,
  items,
  itemProps,
  columns,
  ItemComponent
}: GridListGridProps<TItemProps, TItem>) => (
  <Grid columns={columns} items={items} itemProps={itemProps} ItemComponent={ItemComponent as any} itemGap={gutter} />
);
